export const [MAOLAM_NONE, MAOLAM_WAITING, MAOLAM_REJECTED, MAOLAM_APPROVED] = [0, 1, 2, 3]
export const [DATATYPE_SYSTEM, DATATYPE_BASIC, DATATYPE_BACKTOCHINA, DATATYPE_CONTACT, DATATYPE_ADDRESS, DATATYPE_DOCUMENT, DATATYPE_SCHOOL, DATATYPE_DOSE] = ['system', 'basic', 'backtochina', 'contact', 'address', 'document', 'school', 'dose']
const doseOption = ['', 'Sinovac / 科兴', 'Sinopharm / 国药', 'AstraZeneca / 阿斯利康', 'Pfizer / 辉瑞', 'Moderna / 莫德纳', ]
export const TITLE = {
    role : {
        TH : "ตำแหน่ง",
        CN : "role",
        options : {
            0 : 'User',
            1 : 'Flight Staff',
            //2 : '',
            10 : 'Admin',
        },
        init : 0,
        datatype : DATATYPE_SYSTEM,
    },
    round : {
        TH : "เที่ยวบิน",
        CN : "包机",
        options : {
            0 : '-',
            1 : 'เที่ยวบิน 1',
            2 : 'เที่ยวบิน 2',
            3 : 'เที่ยวบิน 3',
            4 : 'เที่ยวบิน 4',
            5 : 'เที่ยวบิน 5',
            6 : 'เที่ยวบิน 6',
            7 : 'เที่ยวบิน 7',
        },
        init : 0,
        datatype : DATATYPE_BACKTOCHINA, 
    },
    flightIndex : {
        TH : "ลำดับที่",
        CN : "序号",
        init : "",
        datatype : DATATYPE_BACKTOCHINA,
    },
    register : {
        TH : "ประเภทผู้ใช้งาน",
        CN : "User Type",
        options : {
            [false] : 'ลงทะเบียนใหม่',
            [true] : 'เที่ยวบินเหมาลำ'
        },
        init : false,
        datatype : DATATYPE_SYSTEM,
    },


    nameTitle : {
        TH : "คำนำหน้าชื่อ",
        CN : "称谓",
        options : ["-", "MISS", "MR.", "MRS.", 'MASTER'],
        init : '-',
        datatype : DATATYPE_BASIC,
    },
    nameEN : {
        TH : "ชื่อ-นามสกุล (ภาษาอังกฤษ)",
        CN : "英文姓名",
        init : '',
        datatype : DATATYPE_BASIC,
        isUppercase : true,
    },
    nameTitleTH : {
        TH : "คำนำหน้าชื่อ (ภาษาไทย)",
        CN : "泰文称谓",
        init : "",
        options : ['', 'นาย', 'นางสาว', 'นาง', 'เด็กชาย', 'เด็กหญิง'],
        datatype : DATATYPE_BASIC,
    },
    nameTH : {
        TH : "ชื่อ-นามสกุล (ภาษาไทย)",
        CN : "泰文姓名",
        init : "",
        datatype : DATATYPE_BASIC,
    },
    nickName : {
        TH : "ชื่อเล่น",
        CN : "Nickname",
        init : "",
        datatype : DATATYPE_BASIC,
    },
    nameCN : {
        TH : "ชื่อภาษาจีน",
        CN : "中文姓名",
        init : '',
        datatype : DATATYPE_BASIC, 
    },
    birth : {
        TH : "วันเกิด (โปรดใส่แบบจีน : YYYY-MM-DD)",
        CN : "出生日期",
        init : '',
        datatype : DATATYPE_BASIC, 
        isDate : true,
    },


    passport : {
        TH : "หมายเลขหนังสือเดินทาง",
        CN : "护照号码",
        init : '',
        datatype : DATATYPE_BACKTOCHINA,
        isUppercase : true,
    },
    passportExpiredDate : {
        TH : "วันหมดอายุหนังสือเดินทาง",
        CN : "有效期至",
        init : '',
        datatype : DATATYPE_BACKTOCHINA,
        isDate : true,
    },
    nation : {
        TH : "สัญชาติ",
        CN : "国籍",
        options : {'-' : '-', '泰国' : '泰国/THAI'},
        init : '-',
        datatype : DATATYPE_BACKTOCHINA, 
    },
    school : {
        TH : "ชื่อสถาบันการศึกษา (ภาษาจีน)",
        CN : "学校名称",
        init : '',
        datatype : DATATYPE_SCHOOL, 
    },
    province : {
        TH : "มณฑล",
        CN : "省",
        options : {
            '-' : '-', 北京 : '北京/BEIJING', 重庆 : '重庆/CHONGQING', 上海 : '上海/SHANGHAI', 天津 : '天津/TIANJIN', 安徽 : '安徽/ANHUI', 福建 : '福建/FUJIAN', 甘肃 : '甘肃/GANSU', 广东 : '广东/GUANGDONG', 广西 : '广西/GUANGXI', 贵州 : '贵州/GUIZHOU', 海南 : '海南/HAINAN', 河北 : '河北/HEBEI', 黑龙江 : '黑龙江/HEILONGJIANG', 河南 : '河南/HENAN', 湖北 : '湖北/HUBEI', 湖南 : '湖南/HUNAN', 江苏 : '江苏/JIANGSU', 江西 : '江西/JIANGXI', 吉林 : '吉林/JILIN', 辽宁 : '辽宁/LIAONING', 青海 : '青海/QINGHAI', 陕西 : '陕西/SHAANXI', 山东 : '山东/SHANDONG', 山西 : '山西/SHANXI', 四川 : '四川/SICHUAN', 云南 : '云南/YUNNAN', 浙江 : '浙江/ZHEJIANG', 
        },
        init : '-',
        datatype : DATATYPE_SCHOOL, 
    },
    schoolCity : {
        TH : "เมือง (ภาษาจีน)",
        CN : "城市",
        init : '',
        datatype : DATATYPE_SCHOOL, 
    },
    degree : {
        TH : "ระดับการศึกษา",
        CN : "学位",
        options : [
            '-', '初中', '高中', '中专', '大专', '本科', '硕士', '博士', '汉语进修'
        ],
        init : '-',
        datatype : DATATYPE_SCHOOL, 
    },
    year : {
        TH : "ปีที่เรียน",
        CN : "年级",
        options : [
            '-', '初一', '初二', '初三', '高一', '高二', '高三', '一年级', '二年级', '三年级', '四年级', '五年级', '六年级', '汉语进修', 
        ],
        init : '-',
        datatype : DATATYPE_SCHOOL, 
    },
    major : {
        TH : "ชื่อวิชาเอก (ภาษาจีน)",
        CN : "专业",
        init : '',
        datatype : DATATYPE_SCHOOL, 
    },
    endYear : {
        TH : "ปีที่จะสำเร็จการศึกษา",
        CN : "预计结业时间",
        options : [
            '-', '2022年', '2023年', '2024年', '2025年', '2026年', '2027年', '2028年', '2029年', '2030年', 
        ],
        init : '-',
        datatype : DATATYPE_SCHOOL, 
    },
    dose : {
        TH : "จำนวนวัคซีนที่ฉีดแล้ว",
        CN : "完成剂数",
        options : { 0 : '0', 1 : '1', 2 : '2', 3 : '3', 4 : '4', 5 : '5', 6 : '6', 7 : '7', 8 : '8'},
        init : 0,
        datatype : DATATYPE_DOSE, 
    },
    dose1 : {
        TH : "วัคซีนเข็มที่ 1",
        CN : "疫苗种类 (第一剂)",
        options : doseOption,
        init : "",
        datatype : DATATYPE_DOSE, 
    },
    dose2 : {
        TH : "วัคซีนเข็มที่ 2",
        CN : "疫苗种类 (第二剂)",
        options : doseOption,
        init : "",
        datatype : DATATYPE_DOSE, 
    },
    dose3 : {
        TH : "วัคซีนเข็มที่ 3",
        CN : "疫苗种类 (第三剂)",
        options : doseOption,
        init : "",
        datatype : DATATYPE_DOSE, 
    },
    dose4 : {
        TH : "วัคซีนเข็มที่ 4",
        CN : "疫苗种类 (第四剂)",
        options : doseOption,
        init : "",
        datatype : DATATYPE_DOSE, 
    },
    dose5 : {
        TH : "วัคซีนเข็มที่ 5",
        CN : "疫苗种类 (第五剂)",
        options : doseOption,
        init : "",
        datatype : DATATYPE_DOSE, 
    },
    dose6 : {
        TH : "วัคซีนเข็มที่ 6",
        CN : "疫苗种类 (第六剂)",
        options : doseOption,
        init : "",
        datatype : DATATYPE_DOSE, 
    },
    dose7 : {
        TH : "วัคซีนเข็มที่ 7",
        CN : "疫苗种类 (第七剂)",
        options : doseOption,
        init : "",
        datatype : DATATYPE_DOSE, 
    },
    dose8 : {
        TH : "วัคซีนเข็มที่ 8",
        CN : "疫苗种类 (第八剂)",
        options : doseOption,
        init : "",
        datatype : DATATYPE_DOSE, 
    },
    doseLatestDate : {
        TH : "วันที่ฉีดวัคซีนล่าสุด",
        CN : "接种时间",
        init : "",
        datatype : DATATYPE_DOSE, 
        isDate : true,
    },
    telephone : {
        TH : "หมายเลขโทรศัพท์",
        CN : "联系电话",
        init : '',
        datatype : DATATYPE_CONTACT, 
    },
    lineID : {
        TH : "ไอดีไลน์",
        CN : "LINE ID",
        init : '',
        datatype : DATATYPE_CONTACT, 
    },
    wechatID : {
        TH : "ไอดีวีแชท",
        CN : "WeChat ID",
        init : '',
        datatype : DATATYPE_CONTACT, 
    },
    emergency : {
        TH : "หมายเลขโทรศัพท์ติดต่อฉุกเฉิน",
        CN : "紧急联系人的电话",
        init : '',
        datatype : DATATYPE_CONTACT, 
    },
    email : {
        TH : "อีเมล",
        CN : "邮箱",
        init : '',
        datatype : DATATYPE_CONTACT, 
    },
    
    seatType : {
        TH : "ประเภทที่นั่ง",
        CN : "Seat Type",
        options : ["-", 'Business', 'Economy'],
        init : '-',
        datatype : DATATYPE_BACKTOCHINA, 
    },
    visa : {
        TH : "การขอวีซ่า",
        CN : "申请签证",
        options : {
            '-' : '-',
            自己 : 'ทำด้วยตนเอง',
            曼谷 : 'ทำวีซ่ากับสมาคม ที่กรุงเทพ (曼谷)',
            普吉领事办公室 : 'ทำวีซ่ากับสมาคม ที่สำนักงานกงสุลภูเก็ต (普吉领事办公室)',
            孔敬总领馆 : 'ทำวีซ่ากับสมาคม ที่สถานกงสุลใหญ่ขอนแก่น (孔敬总领馆)',
            宋卡总领馆 : 'ทำวีซ่ากับสมาคม ที่สถานกงสุลใหญ่สงขลา (宋卡总领馆)',
            清迈总领馆 : 'ทำวีซ่ากับสมาคม ที่สถานกงสุลใหญ่เชียงใหม่ (清迈总领馆)',
        },
        init : '-',
        datatype : DATATYPE_BACKTOCHINA, 
    },
    food : {
        TH : "การรับประทานอาหาร",
        CN : "",
        options : {
            0 : "รับประทานได้หมด",
            1 : "เฉพาะอาหารฮาลาล",
            2 : "เฉพาะอาหารมังสวิรัติ",
            3 : "เฉพาะอาหารเจ",
            4 : "ไม่รับประทานเนื้อวัว",
            5 : "แพ้อาหารทะเล",
        },
        init : 0,
        datatype : DATATYPE_BACKTOCHINA, 
    },
    pp : {
        TH : "สำเนาหนังสือเดินทาง",
        CN : "PASSPORT COPY",
        init : false,
        datatype : DATATYPE_DOCUMENT,
    },
    cov1 : {
        TH : "ผลตรวจ ATK",
        CN : "ก่อนบิน 14 วัน",
        init : false,
        datatype : DATATYPE_DOCUMENT,
    },
    cov2 : {
        TH : "ผลตรวจ PCR",
        CN : "ก่อนบิน 7 วัน",
        init : false,
        datatype : DATATYPE_DOCUMENT,
    },
    cov3 : {
        TH : "ผลตรวจ PCR",
        CN : "ก่อนบิน 48 ชม.",
        init : false,
        datatype : DATATYPE_DOCUMENT,
    },
    cov4 : {
        TH : "ผลตรวจ PCR",
        CN : "ก่อนบิน 24 ชม.",
        init : false,
        datatype : DATATYPE_DOCUMENT,
    },
    hcode : {
        TH : "รหัสสุขภาพ",
        CN : "健康码",
        init : false,
        datatype : DATATYPE_DOCUMENT,
    },
    othdoc : {
        TH : "เอกสารอื่น ๆ",
        CN : "其他附件",
        init : false,
        datatype : DATATYPE_DOCUMENT,
    },
    telCN : {
        TH : "เบอร์โทรจีน",
        CN : "中国手机号码",
        init : "",
        datatype : DATATYPE_CONTACT,
    },
    isChecked : {
        init : false,
        datatype : DATATYPE_SYSTEM,
    },
    isInfected : {
        init : false,
        datatype : DATATYPE_SYSTEM,
    },
    isHighlight : {
        init : false,
        datatype : DATATYPE_SYSTEM,
    },
    isSharedDaxue : {
        init : false,
        datatype : DATATYPE_SYSTEM,
    },
    note : {
        TH : "หมายเหตุ",
        CN : "",
        init : "",
        datatype : DATATYPE_SYSTEM,
    },
    "addressTHNo": {
        "TH": "บ้านเลขที่",
        "CN": "Number",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHBuilding": {
        "TH": "อาคาร",
        "CN": "Building",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHFloor": {
        "TH": "ชั้น",
        "CN": "Floor",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHVillage": {
        "TH": "หมู่บ้าน",
        "CN": "Village",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHVillageNo": {
        "TH": "หมู่ที่",
        "CN": "Village No.",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHAlley": {
        "TH": "ตรอก",
        "CN": "Alley",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHLane": {
        "TH": "ซอย",
        "CN": "Lane",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHRoad": {
        "TH": "ถนน",
        "CN": "Road",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHSubDistrict": {
        "TH": "ตำบล, แขวง",
        "CN": "Sub-District",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHDistrict": {
        "TH": "อำเภอ, เขต",
        "CN": "District",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHProvince": {
        "TH": "จังหวัด",
        "CN": "Province",
        "init": "",
        options : ["", 'กระบี่', 'กรุงเทพมหานคร', 'กาญจนบุรี', 'กาฬสินธุ์', 'กำแพงเพชร', 'ขอนแก่น', 'จันทบุรี', 'ฉะเชิงเทรา', 'ชลบุรี', 'ชัยนาท', 'ชัยภูมิ', 'ชุมพร', 'เชียงราย', 'เชียงใหม่', 'ตรัง', 'ตราด', 'ตาก', 'นครนายก', 'นครปฐม', 'นครพนม', 'นครราชสีมา', 'นครศรีธรรมราช', 'นครสวรรค์', 'นนทบุรี', 'นราธิวาส', 'น่าน', 'บึงกาฬ', 'บุรีรัมย์', 'ปทุมธานี', 'ประจวบคีรีขันธ์', 'ปราจีนบุรี', 'ปัตตานี', 'พระนครศรีอยุธยา', 'พะเยา', 'พังงา', 'พัทลุง', 'พิจิตร', 'พิษณุโลก', 'เพชรบุรี', 'เพชรบูรณ์', 'แพร่', 'ภูเก็ต', 'มหาสารคาม', 'มุกดาหาร', 'แม่ฮ่องสอน', 'ยโสธร', 'ยะลา', 'ร้อยเอ็ด', 'ระนอง', 'ระยอง', 'ราชบุรี', 'ลพบุรี', 'ลำปาง', 'ลำพูน', 'เลย', 'ศรีสะเกษ', 'สกลนคร', 'สงขลา', 'สตูล', 'สมุทรปราการ', 'สมุทรสงคราม', 'สมุทรสาคร', 'สระแก้ว', 'สระบุรี', 'สิงห์บุรี', 'สุโขทัย', 'สุพรรณบุรี', 'สุราษฎร์ธานี', 'สุรินทร์', 'หนองคาย', 'หนองบัวลำภู', 'อ่างทอง', 'อำนาจเจริญ', 'อุดรธานี', 'อุตรดิตถ์', 'อุทัยธานี', 'อุบลราชธานี'],
        datatype : DATATYPE_ADDRESS,
    },
    "addressTHPostal": {
        "TH": "รหัสไปรษณีย์",
        "CN": "Postal Code",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressCNSheng": {
        "TH": "มณฑล (ที่อยู่จีน)",
        "CN": "省",
        "init": "",
        options : ['', '北京', '重庆', '上海', '天津', '安徽', '福建', '甘肃', '广东', '广西', '贵州', '海南', '河北', '黑龙江', '河南', '湖北', '湖南', '江苏', '江西', '吉林', '辽宁', '青海', '陕西', '山东', '山西', '四川', '云南', '浙江', ],
        datatype : DATATYPE_ADDRESS,
    },
    "addressCNChengshi": {
        "TH": "เมือง (ที่อยู่จีน)",
        "CN": "城市",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressCNQv": {
        "TH": "เขต (ที่อยู่จีน)",
        "CN": "区",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    },
    "addressCNDizhi": {
        "TH": "ที่อยู่  (ที่อยู่จีน)",
        "CN": "地址",
        "init": "",
        datatype : DATATYPE_ADDRESS,
    }
}

export const datatypelist = {
    basic : 'ข้อมูลพื้นฐาน',
    school : 'ข้อมูลการศึกษา',
    backtochina : 'ข้อมูลการเดินทางเข้าจีน',
    dose : 'ข้อมูลการฉีดวัคซีนโควิด',
    contact : 'ข้อมูลติดต่อ',
    address : 'ข้อมูลที่อยู่',
    //system : 'ข้อมูลระบบ',
    document : 'ข้อมูลเอกสาร',
}

export const DB_TITLE = [...Object.keys(TITLE)].filter(v => ![DATATYPE_SYSTEM, DATATYPE_DOCUMENT].includes(TITLE[v].datatype))
export const FREEZE_FIELD = ['round', 'flightIndex', 'nameEN', 'passport']

export const userInitialData = [...Object.keys(TITLE)].reduce((prev, curr) => ({...prev, [curr] : TITLE[curr].init}), {})

export const initialUserUrls = [...Object.keys(TITLE)].filter(v => TITLE[v].datatype === DATATYPE_DOCUMENT).reduce((prev, curr) => ({...prev, [curr] : ''}), {})


export const FileName = {
    pp : 'PASSPORT',
    cov1 : 'ผลตรวจโควิด 1',
    cov2 : 'ผลตรวจโควิด 2',
    cov3 : 'ผลตรวจโควิด 3',
    cov4 : 'ผลตรวจโควิด 4',
    hcode : 'รหัสสุขภาพ',
    othdoc : 'เอกสารอื่น ๆ'
}

export const FileType = [...Object.keys({...FileName})].reduce((ret, key) => {
    ret[FileName[key]] = key;
    return ret;
}, {});

export const FileName2 = {
    pp : 'สำเนาหนังสือเดินทาง',
    cov1 : 'ผลตรวจ ATK ก่อนบิน 14 วัน',
    cov2 : 'ผลตรวจ PCR ก่อนบิน 7 วัน',
    cov3 : 'ผลตรวจ PCR ก่อนบิน 48 ชั่วโมง',
    cov4 : 'ผลตรวจ PCR ก่อนบิน  24 ชั่วโมง',
    hcode : 'รหัสสุขภาพ (健康码)',
    othdoc : 'เอกสารอื่น ๆ (其他附件)'
}

export const colorCode = {
    isChecked : '#b7eb8f',
    isHighlight : '#fffb8f',
    isInfected : '#ffa39e',
    white : 'white',
}